import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import { FormControl, FormGroup, ValidatorFn, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {BetterValidators} from '../../../core/validator/BetterValidators';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-commentaire',
    templateUrl: './modal-commentaire.component.html',
    styleUrls: ['./modal-commentaire.component.scss'],
    imports: [CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class ModalCommentaireComponent implements OnInit, OnDestroy {
    data = inject<{
    content: string;
    cancel?: string;
    confirm?: string;
    commentaire?: string;
    commentaireRequired?: boolean;
    maxLength?: number;
    cols?: number;
    justificationLabel?: string;
}>(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<ModalCommentaireComponent>>(MatDialogRef);
    private translateService = inject(TranslateService);

    content = 'Êtes-vous sur de vouloir effectuer cette action ?';
    cancel = 'Non';
    confirm = 'Oui';
    cols = 10;

    form: FormGroup;

    private subscriptions: Subscription[] = [];

    constructor() {
        const data = this.data;

        this.content = data.content ?? this.translateService.instant('general.modaleConfirmerAction');
        this.cancel = data.cancel ?? this.translateService.instant('general.non');
        this.confirm = data.confirm ?? this.translateService.instant('general.oui');

        this.cols = data?.cols ?? 10;

        const validators = [] as ValidatorFn[];
        if (data.commentaireRequired) {
            validators.push(Validators.required);
            validators.push(BetterValidators.requiredString);
        }
        if (data.maxLength) {
            validators.push(Validators.maxLength(data.maxLength));
        }

        this.form = new FormGroup(
            {
                commentaire: new FormControl(
                    '',
                    validators
                )
            }
        );
    }

    get commentaire() {
        return this.form.get('commentaire').value;
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(item => item.unsubscribe());
    }
}
